// extracted by mini-css-extract-plugin
export default {"app":"layout_app__N5Aoe","content":"layout_content__VePZ0","warning":"layout_warning__X11uf"};